module.exports = __webpack_public_path__ + "static/img/cgxc.40703fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/cgxc.png
// module id = X2Th
// module chunks = 0